import { render, staticRenderFns } from "./crm-price-input.vue?vue&type=template&id=39089efc&"
import script from "./crm-price-input.vue?vue&type=script&lang=js&"
export * from "./crm-price-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports